export enum PrimaryScanEnum {
    Serial = 'Serial',
    AssetID = 'AssetID'
}
